export const tempInitConfig = {
  name: 'TAKO: Asiance (DEV) 1',
  id: 'eafa6d5c-cbdd-4eb6-a9b7-154aefcad9e2',
  key: 'REST-7',
  type: 'REST',
  arguments: {
    executionMode: '{{Context.ExecutionMode}}',
    definitionId: '{{Context.DefinitionId}}',
    activityId: '{{Activity.Id}}',
    contactKey: '{{Context.ContactKey}}',
    execute: {
      inArguments: [],
      url: 'https://dev-api.lets-tako.com/bulk-send',
      verb: 'POST',
      format: 'json',
      body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"asianceReservation01","receiverNum":"{{\\"Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"customerFullName":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}","docentYesNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}","eventName":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.greeting}}","reservationDate":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}","reservationNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.mobileNumber}}","totalVisitorNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}"},"setFallback":"Y","smsOnly":"N","messageSource":"SFMC_JB","bulkSendId":"01KHAYBHFKFTPD2MZB5S3SCCPW"}',
      headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
      timeout: 100000,
      retryCount: 5,
      retryDelay: 10000,
      concurrentRequests: 10,
    },
    testExecute: '',
    startActivityKey: '{{Context.StartActivityKey}}',
    definitionInstanceId: '{{Context.DefinitionInstanceId}}',
    requestObjectId: '{{Context.RequestObjectId}}',
  },
  configurationArguments: {
    save: '',
    testSave: '',
    publish: {
      verb: 'POST',
      url: 'https://dev-api.lets-tako.com/bye',
    },
    testPublish: '',
    unpublish: '',
    stop: '',
    testStop: '',
    testUnpublish: '',
    partnerActivityId: '',
    validate: '',
    testValidate: '',
    outArgumentSchema: '',
    executeSchema: '',
  },
  metaData: {
    isConfigured: true,
  },
  editable: true,
  outcomes: [
    {
      key: '32293d19-7fa3-454d-98c1-e066399ebee3',
      next: 'REST-8',
      arguments: {},
      metaData: {
        invalid: false,
      },
    },
  ],
  errors: null,
};

// export const tempInitConfig = {
//   name: '',
//   id: 'a594e925-d5c5-4dce-a68f-4451c48280bf',
//   key: 'REST-1',
//   type: 'REST',
//   arguments: {
//     execute: {
//       inArguments: [
//         {
//           profileKey: '063665a78ef6dec8f1733711402b1c8adbf31d95',
//           brandCode: 'asiance',
//           reservedTime: '00000000000000',
//           templateCode: '20260107_BM_FI_N',
//           receiverNum:
//             '{{Event.DEAudience-a105d6e8-bede-ce85-b142-da78b76d241e.phoneNumber}}',
//           templateFields: {},
//           setFallback: 'N',
//           targeting: 'N',
//           messageSource: 'SFMC_JB',
//           bulkSendId: '01KEQX5DW9DX5QF0HBR6Z1DV2J',
//           allowFallback: false,
//           overrideVariables: false,
//         },
//       ],
//       url: '"https://dev-api.lets-tako.com/message"',
//       verb: 'POST',
//       format: 'json',
//       body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","messageId":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.id}}","messageType":"AI","reservedTime":"00000000000000","templateCode":"asianceReservation01","receiverNum":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.phoneNumber}}","templateFields":{"customerFullName":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.customerFullName}}","docentYesNo":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.docentYesNo}}","eventName":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.eventName}}","reservationDate":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.reservationDate}}","reservationNo":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.reservationNo}}","totalVisitorNo":"{{Event.DEAudience-51f34a48-56e6-19d8-3866-0c86e39bc0b0.totalVisitorNo}}"},"smsOnly":"N"}',
//       requestHeaders: {
//         'x-api-key': 'XAT0gBjr6H4oHZqzNYjHC17DtM2f06lg7UuJZcfe',
//       },
//     },
//   },
//   configurationArguments: {
//     save: {
//       url: 'https://dev-api.lets-tako.com/hello',
//       verb: 'POST',
//       body: '',
//       useJwt: false,
//     },
//     testSave: {
//       url: 'https://dev-api.lets-tako.com/hello',
//       verb: 'GET',
//     },
//   },
//   metaData: {
//     icon: 'https://tako-sfmc-jb-custom-activity-dev.s3.amazonaws.com/logo192.png',
//     category: 'message',
//     iconSmall: null,
//     statsContactIcon: null,
//     original_icon: 'logo192.png',
//     isConfigured: true,
//   },
//   editable: true,
//   outcomes: [
//     {
//       key: '5e8efbe2-4516-4aed-9836-680f42a4014c',
//       next: 'WAITBYDURATION-1',
//       arguments: {},
//       metaData: {
//         invalid: false,
//       },
//     },
//   ],
//   errors: [
//     {
//       errorDetail:
//         'A custom activity or entry source failed validation. Check to ensure that the activity or entry source publishes to a valid endpoint.',
//       errorCode: '121043',
//       errorType: 'Error',
//       additionalInfo: {
//         exception:
//           'InteractionStudio RestActivity Error Publishing Rest Activity Request to Endpoint on Save. Message | + {"message":"Missing Authentication Token"}',
//         stacktrace:
//           '   at ExactTarget.JourneyBuilder.Services.RestActivityService.PrepareAndCallRestEndpoint(ErrorManager errManager, Guid definitionId, Guid activityId, String apiEventName, JObject apiEvent, Guid applicationExtensionId, String partnerActivityId, Int32 interactionVersion, String interactionKey, Guid originalDefinitionId, Boolean executeAsync)',
//         activityKey: 'REST-4',
//         activityId: '7797c51f-5266-40d0-8a0b-2956562af6d0',
//         activityType: 'REST',
//         definitionId: '2753d2ea-7736-4880-a1cf-5686b2752d70',
//       },
//     },
//   ],
// };

export const tempActivityDefaultValues = {
  profileKey: '063665a78ef6dec8f1733711402b1c8adbf31d95',
  smsOnly: 'N',
  setFallback: 'Y',
  templateFields: {
    customerFullName:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}',
    eventName:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.greeting}}',
    totalVisitorNo:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}',
    reservationDate:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}',
    docentYesNo:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}',
    reservationNo:
      '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.mobileNumber}}',
  },
  bulkSendId: '01KHAYBHFKFTPD2MZB5S3SCCPW',
  messageSource: 'SFMC_JB',
  receiverNum:
    '{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c}}',
  templateCode: 'asianceReservation01',
  reservedTime: '00000000000000',
  overrideVariables: true,
  brandCode: 'asiance',
  allowFallback: true,
};

/** sample data returned when requestedTriggerEventDefinition is triggered */
export const SampleDataRequestedTriggerEventDefinition = {
  id: '9F0DFB00-BC33-47C0-98C3-6E6DA514104E',
  name: 'New Journey - February 13 2026 at 3.59 PM',
  mode: 'Production',
  isVisibleInPicker: false,
  type: 'EmailAudience',
  iconUrl: '/images/icon-data-extension.svg',
  eventDefinitionKey: 'DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425',
  dataExtensionId: '19193ac6-8f08-f111-a5d5-5cba2c196e68',
  createdDate: '2026-02-12T15:59:39.7930Z',
  createdBy: 747112097,
  modifiedDate: '2026-02-12T15:59:39.7930Z',
  modifiedBy: 747112097,
  dataExtensionName: 'bm-tests-001_Copy',
  sourceApplicationExtensionId: '97e942ee-6914-4d3d-9e52-37ecb71f79ed',
  isPlatformObject: false,
  category: 'Audience',
  disableDEDataLogging: false,
  deRecordCount: 6,
  metaData: {
    scheduleState: 'No Schedule',
    criteriaDescription: null,
    scheduleFlowMode: 'runOnce',
    runOnceScheduleMode: 'onPublish',
  },
  arguments: {
    serializedObjectType: 3,
    eventDefinitionId: '9f0dfb00-bc33-47c0-98c3-6e6da514104e',
    eventDefinitionKey: 'DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425',
    dataExtensionId: '19193ac6-8f08-f111-a5d5-5cba2c196e68',
    criteria: '',
    useHighWatermark: false,
    automationId: '3f255a1a-6d4c-4775-83c3-0e97bc765ce2',
  },
  configurationArguments: {
    unconfigured: false,
  },
};

export const SampleDataRequestedInteractionHandler = {
  id: '0f964bd6-b204-4c4b-b964-319ee1ae1472',
  version: 4,
  useDefinitionId: false,
  name: 'New Journey - February 13 2026 at 3.59 PM',
  description: '',
  workflowApiVersion: 1,
  entryMode: 'MultipleEntries',
  activities: [
    {
      key: 'REST-7',
      name: 'TAKO: Asiance (DEV) 1',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '32293d19-7fa3-454d-98c1-e066399ebee3',
          next: 'REST-8',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"asianceReservation01","receiverNum":"{{\\"Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"customerFullName":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}","docentYesNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}","eventName":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.greeting}}","reservationDate":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}","reservationNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.mobileNumber}}","totalVisitorNo":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.id}}"},"setFallback":"Y","smsOnly":"N","messageSource":"SFMC_JB","bulkSendId":"01KHAYBHFKFTPD2MZB5S3SCCPW"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-8',
      name: 'TAKO: Asiance (DEV) 2',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '7c113f20-b539-4cc3-9bee-39677dd44c70',
          next: 'REST-9',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"asdf","receiverNum":"{{\\"Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{},"setFallback":"N","messageSource":"SFMC_JB","bulkSendId":"01KHB97821DCR8K7BF92TCZ6NW"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-9',
      name: 'TAKO: Asiance (DEV) 3',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '2bdb46af-c9cb-4d54-9233-494e85cf3e51',
          next: 'REST-10',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"251204test","receiverNum":"{{\\"Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"Username":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.fullName}}"},"smsOnly":"N","setFallback":"Y","messageSource":"SFMC_JB","bulkSendId":"01KHB9839M7EFR9N8KW8BQ6YR6"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-10',
      name: 'TAKO: Asiance (DEV) 4',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: 'a8a25f43-906b-447d-aa04-bec6343de7f0',
          next: null,
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"Purchase_Completed","receiverNum":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"Firstname":"{{Event.DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425.\\"firstName\\"}}"},"setFallback":"N","messageSource":"SFMC_JB","bulkSendId":"01KHB9AHGBVFB4EQ4SGVRGW52A"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
  ],
  notifiers: [],
  persistenceModel_asyncStopping: {},
  persistenceModel_pausing: {},
  persistenceModel_resuming: {},
  metaData: {
    dataSource: 'ContactsModel',
    disableEndWait: true,
    highThroughputSending: {
      email: false,
    },
  },
  key: '38561570-ee67-168f-1303-e772ed9a903c',
  createdDate: '2026-02-13T10:40:23.0000Z',
  modifiedDate: '2026-02-13T10:40:23.0000Z',
  goals: [],
  exits: [],
  definitionType: 'Multistep',
  channel: '',
  executionMode: 'Production',
  categoryId: 23793,
  definitionId: 'dc1333bb-f8bc-4476-8036-4378c89a6772',
  scheduledStatus: 'Draft',
  campaigns: [],
  defaults: {
    email: [],
    mobileNumber: [],
    transactionKeys: null,
    contactErrorBehavior: {},
    properties: {
      analyticsTracking: {
        enabled: false,
        analyticsType: 'google',
        urlDomainsToTrack: [],
      },
    },
  },
  triggers: [
    {
      key: 'TRIGGER',
      name: 'TRIGGER',
      description: '',
      type: 'EmailAudience',
      arguments: {
        startActivityKey: '{{Context.StartActivityKey}}',
        dequeueReason: '{{Context.DequeueReason}}',
        lastExecutedActivityKey: '{{Context.LastExecutedActivityKey}}',
        filterResult: 'true',
      },
      configurationArguments: {
        filterDefinitionId: '00000000-0000-0000-0000-000000000000',
        criteria: '',
        schemaVersionId: 0,
      },
      metaData: {
        sourceInteractionId: '00000000-0000-0000-0000-000000000000',
        eventDefinitionId: '9F0DFB00-BC33-47C0-98C3-6E6DA514104E',
        eventDefinitionKey: 'DEAudience-dc046ea8-f8ca-ab85-7157-bfe2e5d81425',
        chainType: 'none',
        configurationRequired: false,
        iconUrl: '/images/icon-data-extension.svg',
        title: 'Data Extension',
        entrySourceGroupConfigUrl:
          'jb:///data/entry/audience/entrysourcegroupconfig.json',
      },
    },
  ],
  transactionKeys: null,
  status: 'DRAFT',
};
